import {makeGetContactData} from 'main/factories/usecases/private/profile/get-contact-data';
import {getUserInfoFromToken} from 'presentation/utils';

export async function getContactData(signal: AbortSignal) {
	const {cdPessoa} = getUserInfoFromToken();

	const {contato} = await makeGetContactData().get({
		signal,
		cdPessoa,
	});

	if (!contato) {
		return {
			cdPessoa,
			telefone: '',
			email: '',
			endereco: {
				nmUf: '',
				nmCidade: '',
				nmBairro: '',
				nmTipoLogradouro: '',
				nmRua: '',
				nuEndereco: '',
				nuCep: '',
				dsComplemento: '',
			},
		};
	}

	if (
		!contato.endereco ||
		!contato.endereco.nmUf ||
		!contato.endereco.nmCidade ||
		!contato.endereco.nmBairro ||
		!contato.endereco.nmTipoLogradouro ||
		!contato.endereco.nmRua ||
		!contato.endereco.nuCep
	) {
		return {
			...contato,
			endereco: {
				nmUf: '',
				nmCidade: '',
				nmBairro: '',
				nmTipoLogradouro: '',
				nmRua: '',
				nuEndereco: '',
				nuCep: '',
				dsComplemento: '',
			},
		};
	}

	return {
		...contato,
		endereco: {
			...contato.endereco,
			nuEndereco: contato.endereco.nuEndereco ? contato.endereco.nuEndereco.toString() : '',
		},
	};
}
